var ReservationBuilderConstants = {

  ADD_CARD:                 'addCard',
  ADD_ONS:                  'addOns',
  ADD_VOUCHER:              'addVoucher',
  ADD_RESERVATION_SEGMENT:  'addReservationSegment',
  APPLY_GROUP_CONTRACT:     'applyGroupContract',
  CALCULATE_PRICING:        'calculatePricing',
  CARD_ELEMENT_KEY_INCREMENTED: 'cardElementKeyIncremented',
  CHANGE_ADD_ONS_RESERVATION_SEGMENT_ID: 'CHANGE_ADD_ONS_RESERVATION_SEGMENT_ID',
  CLEAR_CUSTOMER:           'clearCustomer',
  CHANGE_BOOKING_PAYMENT_AMOUNT:  'changeBookingPaymentAmount',
  CHANGE_ADD_ONS:           'changeAddOns',
  CHANGE_CARD_INPUT:        'changeCardInput',
  CHANGE_DATES:             'changeDates',
  CHANGE_GUEST_TYPE_COUNT:  'changeGuestTypeCount',
  CHANGE_EVENT:             'changeEvent',
  CHANGE_TYPE_OF_BOOKING:   'changeTypeOfBooking',
  CHANGE_PROMO_CODE:        'changePromoCode',
  DISABLE_CARD_NAME_INPUT:  'disableCardNameInput',
  SUBMIT_PROMO_CODE:        'submitPromoCode',
  INIT:                     'init',
  GOTO_STEP:                'gotoStep',
  HIDE_RATES:               'hideRates',
  JUMPTO_STEP:              'jumptoStep',
  ACCOMMODATIONS:           'accommodations',
  BILLING:                  'billing',
  SUCCESS:                  'success',
  SUMMARY:                  'summary',
  BILLING_SUMMARY:          'billingSummary',
  CUSTOMER_INFORMATION:     'customerInformation',
  PAYMENT_INFORMATION:     'paymentInformation',
  CUSTOMER_AND_CREDIT_CARD: 'customerAndCreditCard',
  PAYMENT_DETAILS:          'paymentDetails',
  REVIEW_SUMMARY:         'reviewSummary',
  REMOVE_SEGMENT:           'removeSegment',
  RESET_CARD_DETAILS:       'resetCardDetails',
  SET_BILLING_POLICY:         'setBillingPolicy',
  SET_BUTTONS:                'setButtons',
  SET_CARD_ERRORS_TO_STATE:    'setCardErrorsToState',
  SET_CUSTOMER:               'setCustomer',
  SET_FORM_FIELDS:            'setFormFields',
  SET_FORMS:                  'setForms',
  SET_VALUE:                  'setValue',
  SAVE:                       'save',
  NEXT:                       'next',
  PREV:                       'prev',
  UPDATE_SEGMENT:             'updateSegment',
  UPDATE_SEGMENT_GUEST_COUNT: 'updateSegmentGuestCount',
  VIEW_RATES:                 'viewRates',
  SET_EMOJI_STATE: 'setEmojiState',
  SET_RATING_STATE: 'setRatingState',
  ADDITIONAL_INFORMATION: 'additionalInformation',
  LOADING: 'loading',
  DATE_RANGE_PICKER_VISIBLE: 'dateRangePickerVisible',
};

export default ReservationBuilderConstants
